import { Routes } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { FormComponent } from './form/form.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { environment } from "../environments/environment";

export const ROUTES: Routes = [
  {
    path: ':id/welcome',
    component: WelcomeComponent,
    pathMatch: 'full',
    data: {
      state: 'welcome'
    }
  },
  {
    path: ':id/form',
    component: FormComponent,
    pathMatch: 'full',
    data: {
      state: 'form'
    }
  },
  {
    path: ':id/confirm',
    component: ConfirmComponent,
    pathMatch: 'full',
    data: {
      state: 'confirm'
    }
  },
  {
    path: ':id',
    pathMatch: 'full',
    redirectTo: ':id/welcome',
  },
  {
    path: '',
    redirectTo: environment.projectID + '/welcome',
    pathMatch: 'full'
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts